import { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem("sv_cart");
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("sv_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((p) => p.lookup_key === product.lookup_key);
      if (found) {
        return prev.map((p) => (p.lookup_key === product.lookup_key ? { ...p, quantity: p.quantity + qty } : p));
      }
      return [
        ...prev,
        {
          lookup_key: product.lookup_key,
          slug: product.slug,
          name: product.name,
          price_aud: product.price_aud,
          tier: product.tier,
          image_url: product.image_url,
          quantity: qty,
        },
      ];
    });
  };
  const remove = (lookup_key) => setItems((prev) => prev.filter((p) => p.lookup_key !== lookup_key));
  const setQty = (lookup_key, qty) =>
    setItems((prev) => prev.map((p) => (p.lookup_key === lookup_key ? { ...p, quantity: Math.max(1, qty) } : p)));
  const clear = () => setItems([]);

  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  const total = useMemo(() => items.reduce((s, i) => s + i.price_aud * i.quantity, 0), [items]);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, total }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
